import { render, staticRenderFns } from "./AmazoniaProtege.vue?vue&type=template&id=12796bab&lang=pug"
import script from "./AmazoniaProtege.vue?vue&type=script&lang=js"
export * from "./AmazoniaProtege.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports